import { createReducer } from '../../utilities/miscellaneous'

// initial state
export const INITIAL_STATE = ({
  submitting: false,
  success: false,
  error: false,
})

// action types
export const SUBMIT = 'contact/SUBMIT'
export const SUBMITTED = 'contact/SUBMITTED'
export const ERROR = 'contact/ERROR'
export const CLEAN = 'contact/CLEAN'

// submit :: (String, String, String, String, String) -> Action
export const submit = (
  name,
  email,
  serviceToContact,
  subject,
  content,
  captcha,
) => ({
  type: SUBMIT,
  name,
  email,
  serviceToContact,
  subject,
  content,
  captcha,
})

// submitted :: () -> Action
export const submitted = () => ({ type: SUBMITTED })

// error :: () -> Action
export const error = () => ({ type: ERROR })

// clean :: () -> Action
export const clean = () => ({ type: CLEAN })

// contact :: (State, Action *) -> State
export default createReducer(INITIAL_STATE, {
  [SUBMIT]: state => ({
    ...state,
    submitting: true,
    success: false,
    error: false,
  }),

  [SUBMITTED]: state => ({
    ...state,
    submitting: false,
    success: true,
    error: false,
  }),

  [ERROR]: state => ({
    ...state,
    submitting: false,
    success: false,
    error: true,
  }),

  [CLEAN]: () => INITIAL_STATE,
})
